
import React, { Component } from "react";

class CpfNotFound extends Component {

  render() {
    const { os } = this.props;
    return <section id="errorComponent">
      <div>
        <div>
          <div className="wrap-content-email">
            <h2 className="blue">
              O CPF não foi encontrado na instituição {this.props.company}
            </h2>
            <p>
              Entre em contato com seu gestor para ele fazer o pré-cadastro.
            </p>
          </div>
        </div>
      </div>
    </section>
  }
} export default CpfNotFound;


// WEBPACK FOOTER //
// ./src/app/home/container/cpfNotFound.js